import { render, staticRenderFns } from "./productItemList.vue?vue&type=template&id=4db490a7&scoped=true&"
import script from "./productItemList.vue?vue&type=script&lang=js&"
export * from "./productItemList.vue?vue&type=script&lang=js&"
import style0 from "./productItemList.vue?vue&type=style&index=0&id=4db490a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db490a7",
  null
  
)

export default component.exports